import { LitElement, html } from 'lit';
import { customElement, query, property } from 'lit/decorators.js';
import styles from './product-menu.styles.scss';

export const MENU_TAG = 'spog-common-menu-product-menu' as const;

const DIALOG_ID = 'platform-submenu-dialog' as const;

/**
 * Menu used to display individual
 * product's title and associated
 * submenus.
 */
@customElement(MENU_TAG)
export class SpogProductMenu extends LitElement {
  static override styles = [styles];

  @property({ type: Boolean })
  enabled = false;

  @property({ type: Boolean, reflect: true })
  selected = false;

  @property({ type: Boolean, reflect: true })
  currentProduct = false;

  @query(`#${DIALOG_ID}`)
  private dialog!: HTMLDialogElement;

  override updated() {
    if (this.selected) {
      this.dialog.show();
    } else {
      this.dialog.close();
    }
  }

  private handleClick(event: Event) {
    if (event.target === this.dialog) {
      this.dialog.close();
    }
  }

  override render() {
    return html`
      <slot name="header"></slot>

      <dialog id="${DIALOG_ID}" @click="${this.handleClick}">
        <slot name="sub-menu"></slot>
      </dialog>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [MENU_TAG]: SpogProductMenu;
  }
}
